import { Hotel } from "@/modules/hotels/interfaces/hotelDetailsResponse";
import { defineStore } from "pinia";
import { ref } from "vue";

const defaults = {
  hotel: {
    id: "",
    image: "",
    name: "",
    rating: null,
    favorite: false,
    rooms: [],
    address: undefined,
    latitude: "",
    longitude: "",
    amenities: [],
    agreement: false,
    texts: [],
    images: [],
    attractions: [],
    refPoints: [],
  },
};

export const useHotelStore = defineStore("hotel", () => {
  const hotel = ref<Hotel>({
    ...defaults.hotel,
  });
  const travelers = ref<number[]>([]);

  return {
    hotel,
    travelers,

    setHotel(newHotel: Hotel) {
      hotel.value = newHotel;
    },
    setTravelers(newTravelers: number[]) {
      travelers.value = newTravelers;
    },
  };
});
